import { render, staticRenderFns } from "./BaseSwitch.vue?vue&type=template&id=c3d0ea80&scoped=true&"
import script from "./BaseSwitch.vue?vue&type=script&lang=ts&"
export * from "./BaseSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./BaseSwitch.vue?vue&type=style&index=0&id=c3d0ea80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3d0ea80",
  null
  
)

export default component.exports